export default {
    loading: {
        display: "flex",
        height: "100%",
        alignItems: "center",
        justifyContent: "center"
    },
    selectContainer: {
        minWidth: 140,
        maxWidth: "100%",
        width: "100%"
    },
    dialogContent: {
        padding: 2
    },
    dialogActions: {
        padding: 2
    },
    dialogSaveBtn: {
        width: "30%",
        textAlign: "center",
        margin: "0 auto"
    },
    closeButton: {
        position: "absolute",
        right: 10,
        top: 10
    }
};
